import React from 'react';
import { track } from '../lib/analytics';

const INSTAGRAM_URL =
  'https://www.instagram.com/yup_this_ones_for_you?igsh=ZnAza3A1dTZ1eGF4';
const TIKTOK_URL =
  'https://www.tiktok.com/@yourunmaskingprocess?_r=1&_t=ZN-96Inv0mSd2V';

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      style={{
        padding: '40px 24px',
        textAlign: 'center',
        borderTop: '1px solid var(--yup-border)',
        fontSize: '12px',
        color: 'var(--yup-muted)',
        letterSpacing: '0.5px',
      }}
    >
      <span
        className="font-serif"
        style={{
          fontSize: '18px',
          fontWeight: 600,
          letterSpacing: '3px',
          color: 'var(--yup-accent)',
          textTransform: 'uppercase',
          display: 'block',
          marginBottom: '12px',
        }}
      >
        YUP
      </span>
      <div>
        Your Unmasking Process · yourunmaskingprocess.com
      </div>
      <div
        data-testid="footer-social"
        style={{
          marginTop: '14px',
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
        }}
      >
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track('outbound_click', { value: 'instagram' })}
          data-testid="footer-social-instagram"
          style={{
            color: 'var(--yup-muted)',
            textDecoration: 'none',
            fontSize: '12px',
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            borderBottom: '1px solid var(--yup-border)',
            paddingBottom: '2px',
            transition: 'color 0.2s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--yup-accent)')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--yup-muted)')}
        >
          Instagram
        </a>
        <a
          href={TIKTOK_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track('outbound_click', { value: 'tiktok' })}
          data-testid="footer-social-tiktok"
          style={{
            color: 'var(--yup-muted)',
            textDecoration: 'none',
            fontSize: '12px',
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            borderBottom: '1px solid var(--yup-border)',
            paddingBottom: '2px',
            transition: 'color 0.2s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--yup-accent)')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--yup-muted)')}
        >
          TikTok
        </a>
      </div>
      <div style={{ marginTop: '14px', color: 'var(--yup-muted)' }}>
        © {new Date().getFullYear()} YUP · Built with honesty
      </div>
    </footer>
  );
};

export default Footer;
